/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function VisaWhite(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'VisaWhite',
      'aria-hidden': true,
      focusable: false,
      width:  35 * scale,
      height: 25 * scale,
      viewBox: '0 0 35 25',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('g', {"fill":"none","fillRule":"evenodd"},createElement('rect', {"width":"35","height":"25","fill":"#FFF","rx":"3.316"}),createElement('path', {"fill":"#224DBA","d":"M11.925 16.674H9.874l-1.538-6c-.073-.276-.228-.52-.456-.635A6.6 6.6 0 0 0 6 9.404v-.231h3.304c.456 0 .798.347.855.75l.798 4.328 2.05-5.078h1.994zm4.216 0h-1.937l1.595-7.501h1.937zm4.101-5.423c.057-.404.399-.635.798-.635a3.54 3.54 0 0 1 1.88.346l.342-1.615A4.8 4.8 0 0 0 21.496 9c-1.88 0-3.248 1.039-3.248 2.481 0 1.097.969 1.673 1.653 2.02.74.346 1.025.577.968.923 0 .519-.57.75-1.139.75a4.8 4.8 0 0 1-1.994-.462l-.342 1.616a5.5 5.5 0 0 0 2.108.404c2.108.057 3.418-.981 3.418-2.539 0-1.962-2.678-2.077-2.678-2.942m9.457 5.423-1.538-7.501h-1.652a.86.86 0 0 0-.798.577l-2.848 6.924h1.994l.398-1.096h2.45l.228 1.096zm-2.905-5.481.569 2.827h-1.595z"})))
}
